class AssociatedTemplateLinksCtrl {
  constructor(AuthService, TemplateService, FlashService, SignedLinkSummaryBuilder, UrlClipCopy, $uibModal, $timeout) {
    'ngInject';
    this.as = AuthService;
    this.ts = TemplateService;
    this.fs = FlashService;
    this.summaryBuilder = SignedLinkSummaryBuilder;
    this.urlClipCopy = UrlClipCopy;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.sortKey = 'updatedAt';
    this.sortReverse = true;
    this.toggling = {};
    this.setColumns();
    this.loadingNote = ' ';
    this.records = [];
    this.createNew = () => this.onNewLink();
    this.loadRecords();
  }

  setColumns() {
    const openRow = (_value, record) => this.onRecordSelected(record);
    this.columns = [
      {
        header: 'Actions',
        key: 'linkId',
        style: {
          textAlign: 'left',
          whiteSpace: 'nowrap',
        },
        format: (_value, _index, record) => this.formatActionsCell(record),
        onClick: (_value, record, _index, $event) => {
          if ($event?.target?.closest?.('[data-action]')) {
            this.onActionsClick(record, $event);
            return;
          }
          this.onRecordSelected(record);
        },
      },
      {
        header: 'Description',
        key: 'fieldSort',
        sortable: true,
        format: (_value, _index, record) => this.formatDescriptionCell(record),
        onClick: openRow,
      },
      {
        header: 'Location',
        key: 'tableSort',
        sortable: true,
        style: { width: '28%' },
        format: (_value, _index, record) => this.formatLocationCell(record),
        onClick: openRow,
      },
      {
        header: 'Target Table Actions',
        key: 'targetsSummary',
        sortable: false,
        style: { maxWidth: '280px' },
        format: (value) => (value ? `${value}` : ''),
        onClick: openRow,
      },
      {
        key: 'active',
        header: 'Active',
        sortable: true,
        style: { maxWidth: '74px', width: '74px', textAlign: 'center' },
        format: (_value, _index, record) => {
          const classes = this.toggling[record.linkId]
            ? 'fa-refresh fa-spin'
            : (record.active ? 'fa-check text-success' : 'fa-times text-danger');
          return `<i class="fa ${classes} text-muted"></i>`;
        },
        onClick: (_value, record) => this.toggleActive(record),
      },
      {
        key: 'updatedAt',
        header: 'Updated',
        sortable: true,
        style: { maxWidth: '98px', width: '98px' },
        format: (value) =>
          `<span>${value ? new Date(value).toLocaleDateString('en-US') : ''}</span>`,
        onClick: openRow,
      },
    ];
  }

  isDefaultTemplateLink(linkId) {
    const defaultId = this.ts.template?.defaultTemplateLinkId;
    return defaultId != null && linkId != null && String(defaultId) === String(linkId);
  }

  formatActionsCell(record) {
    const link = record.link;
    const openDisabled = record.publicUrl ? '' : ' disabled';
    const isDefaultLink = !!record.isDefaultLink || this.isDefaultTemplateLink(record.linkId);
    const isWebhookLink = link?.type === 'generate' || link?.type === 'import';
    const deleteDisabled = isDefaultLink ? ' disabled' : '';
    const deleteTitle = isDefaultLink
      ? 'The default template link cannot be deleted.'
      : 'Delete this link';
    const cloneDisabled = isDefaultLink || isWebhookLink ? ' disabled' : '';
    const cloneTitle = isDefaultLink
      ? 'The default template link cannot be cloned.'
      : (isWebhookLink
        ? 'Webhook links cannot be cloned.'
        : 'Clone this link');

    if (isWebhookLink) {
      return `<div class="btn-group btn-group-xs associated-template-links-actions" role="group">
      <a href="" class="btn btn-link${openDisabled}" data-action="view" title="Open webhook"><i class="fa fa-external-link"></i> Webhook</a>
      <a href="" class="btn btn-link" data-action="info" title="Link Summary"><i class="fa fa-info-circle"></i> Info</a>
      <a href="" class="btn btn-link${cloneDisabled}" data-action="clone" title="${cloneTitle}"><i class="fa fa-copy"></i> Clone</a>
      <a href="" class="btn btn-link text-danger${deleteDisabled}" data-action="delete" title="${deleteTitle}"><i class="fa fa-trash"></i> Delete</a>
    </div>`;
    }
    const openLabel = link?.type === 'url' ? 'Link' : 'Field';
    const openTitle = link?.type === 'url' ? 'Open form link' : 'Open Quickbase field';
    return `<div class="btn-group btn-group-xs associated-template-links-actions" role="group">
      <a href="" class="btn btn-link${openDisabled}" data-action="view" title="${openTitle}"><i class="fa fa-external-link"></i> ${openLabel}</a>
      <a href="" class="btn btn-link" data-action="info" title="Link Summary"><i class="fa fa-info-circle"></i> Info</a>
      <a href="" class="btn btn-link${cloneDisabled}" data-action="clone" title="${cloneTitle}"><i class="fa fa-copy"></i> Clone</a>
      <a href="" class="btn btn-link text-danger${deleteDisabled}" data-action="delete" title="${deleteTitle}"><i class="fa fa-trash"></i> Delete</a>
    </div>`;
  }

  onRecordSelected(record) {
    if (!record?.link) return;
    if (record.link.type === 'generate' || record.link.type === 'import') {
      this.afterListDismiss(() => this.openLinkSummary(record));
      return;
    }
    this.onEditLink({ link: record.link });
  }

  afterListDismiss(callback) {
    this.onDismissList();
    this.$timeout(() => callback(), 0);
  }

  onActionsClick(record, $event) {
    const el = $event?.target?.closest?.('[data-action]');
    if (!el) return;
    const action = el.getAttribute('data-action');
    $event.preventDefault();
    $event.stopPropagation();
    if (action === 'view') {
      if (record.publicUrl) {
        window.open(record.publicUrl, '_blank', 'noopener,noreferrer');
      }
      return;
    }
    if (action === 'info') {
      this.afterListDismiss(() => this.openLinkSummary(record));
      return;
    }
    if (action === 'clone') {
      this.afterListDismiss(() => this.requestCloneFromList(record));
      return;
    }
    if (action === 'delete') {
      this.afterListDismiss(() => this.requestDeleteFromList(record));
    }
  }

  requestCloneFromList(record) {
    const link = record?.link;
    const linkId = record?.linkId || link?.linkId;
    const isDefaultLink = !!record?.isDefaultLink || this.isDefaultTemplateLink(linkId);
    const isWebhookLink = link?.type === 'generate' || link?.type === 'import';
    if (!link || !linkId || isDefaultLink || isWebhookLink) return;
    this.openCloneLinkModal({ record, link, linkId });
  }

  requestDeleteFromList(record) {
    const link = record?.link;
    const linkId = record?.linkId || link?.linkId;
    const isDefaultLink = !!record?.isDefaultLink || this.isDefaultTemplateLink(linkId);
    if (!link || !linkId || isDefaultLink) return;
    this.openDeleteLinkConfirm({
      record,
      link,
      linkId,
      hasProviderArtifact: this.linkHasProviderArtifact(link),
    });
  }

  openLinkSummary(record) {
    const link = record?.link || record;
    const summary = this.summaryBuilder.fromLinkListItem(
      link,
      this.ts.references || [],
      record?.linkId
    );
    const linkId = summary.linkId || link?.linkId;
    if (link?.type === 'url' && linkId && this.ts.template?.id) {
      summary.shareUrl = this.urlClipCopy.getUrlLinkUrl(this.ts.template, linkId);
    }

    this.$uibModal.open({
      template: `<div class="modal-header">
          <h3 class="modal-title">Link Summary</h3>
        </div>
        <div class="modal-body">
          <signed-link-summary summary="$ctrl.summary"></signed-link-summary>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" ng-click="$ctrl.close()">Close</button>
        </div>`,
      controller: ['$uibModalInstance', 'summary', function LinkSummaryModalCtrl($uibModalInstance, summary) {
        this.summary = summary;
        this.close = () => $uibModalInstance.close();
      }],
      controllerAs: '$ctrl',
      resolve: {
        summary: () => summary,
      },
      size: 'lg',
      backdrop: 'static',
    });
  }

  linkHasProviderArtifact(link) {
    if (!link || link.type === 'url') return false;
    const fieldId = link.field?.id != null ? String(link.field.id).trim() : '';
    return !!fieldId;
  }

  openDeleteLinkConfirm({ record, link, linkId, hasProviderArtifact }) {
    const label = (link?.field && link.field.label) || 'this link';
    const parent = this;

    const confirmModal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Delete link</h4>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete "${label}"? This action cannot be undone.</p>
          <div ng-if="$ctrl.hasProviderArtifact" class="checkbox" style="margin-top:12px;">
            <label>
              <input type="checkbox" ng-model="$ctrl.deleteProviderFields">
              Also delete link fields and webhooks in QuickBase
            </label>
          </div>
          <div ng-if="$ctrl.deleting" style="height:60px;margin-top:12px;">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" ng-click="$ctrl.confirmDelete()" ng-disabled="$ctrl.deleting">Delete</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.deleting">Cancel</button>
        </div>
      `,
      controller: ['$uibModalInstance', function DeleteLinkConfirmCtrl($uibModalInstance) {
        this.hasProviderArtifact = hasProviderArtifact;
        this.deleteProviderFields = true;
        this.deleting = false;
        this.cancel = () => $uibModalInstance.dismiss('cancel');
        this.confirmDelete = () => {
          if (this.deleting) return;
          this.deleting = true;
          parent.confirmDeleteLink({
            record,
            linkId,
            deleteProviderFields: hasProviderArtifact && this.deleteProviderFields,
            confirmModal: $uibModalInstance,
            onDone: () => { this.deleting = false; },
          });
        };
      }],
      controllerAs: '$ctrl',
      size: 'sm',
    });
  }

  confirmDeleteLink({ record, linkId, deleteProviderFields, confirmModal, onDone }) {
    if (!linkId || !this.templateId) {
      onDone?.();
      return;
    }

    const request = this.as.includeConnectionInRequest({
      payload: {
        action: 'deleteLink',
        templateId: this.templateId,
        linkId,
        ...(deleteProviderFields ? { deleteProviderFields: true } : {}),
      },
    });

    this.ts.linkManagement(request)
      .then((response) => {
        this.records = (this.records || []).filter((r) => String(r.linkId) !== String(linkId));
        const label = record?.fieldLabel || 'Link';
        this.fs.success(`Link "${label}" was deleted successfully!`);
        const warnings = response?.data?.providerFieldWarnings;
        if (Array.isArray(warnings) && warnings.length) {
          this.fs.warning(warnings.join('\n'));
        }
        confirmModal?.close();
      }, () => {
        this.fs.error('There was an error deleting the link!');
        onDone?.();
      });
  }

  openCloneLinkModal({ record, link, linkId }) {
    const sourceLabel = (link?.field && link.field.label) || record?.fieldLabel || '';
    const parent = this;

    const cloneModal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Clone link</h4>
        </div>
        <div class="modal-body">
          <p>Create a copy of this link with a new description.</p>
          <div class="form-group" style="margin-top:12px;">
            <label for="clone-link-description">Description</label>
            <input id="clone-link-description"
              type="text"
              class="form-control"
              ng-model="$ctrl.label"
              ng-disabled="$ctrl.cloning"
              autofocus
              required>
          </div>
          <div ng-if="$ctrl.cloning" style="height:60px;margin-top:12px;">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
            class="btn btn-primary"
            ng-click="$ctrl.confirmClone()"
            ng-disabled="$ctrl.cloning || !$ctrl.label.trim()">
            Clone
          </button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.cloning">Cancel</button>
        </div>
      `,
      controller: ['$uibModalInstance', function CloneLinkModalCtrl($uibModalInstance) {
        this.label = sourceLabel ? `${sourceLabel} (copy)` : '';
        this.cloning = false;
        this.cancel = () => $uibModalInstance.dismiss('cancel');
        this.confirmClone = () => {
          const label = String(this.label || '').trim();
          if (!label || this.cloning) return;
          this.cloning = true;
          parent.confirmCloneLink({
            linkId,
            label,
            cloneModal: $uibModalInstance,
            onDone: () => { this.cloning = false; },
          });
        };
      }],
      controllerAs: '$ctrl',
      size: 'sm',
    });
  }

  confirmCloneLink({ linkId, label, cloneModal, onDone }) {
    if (!linkId || !this.templateId || !label) {
      onDone?.();
      return;
    }

    const request = this.as.includeConnectionInRequest({
      payload: {
        action: 'cloneLink',
        templateId: this.templateId,
        linkId,
        label,
        origin: window.location.origin,
      },
    });

    this.ts.linkManagement(request)
      .then(async (response) => {
        const createdLinkId = response?.data?.createdLink?.linkId;
        this.fs.success(`Link "${label}" was cloned successfully!`);
        cloneModal?.close();
        await this.loadRecords();
        const clonedRecord = (this.records || []).find(
          (r) => createdLinkId && String(r.linkId) === String(createdLinkId)
        );
        if (clonedRecord?.link) {
          this.$timeout(() => this.onEditLink({ link: clonedRecord.link }));
        }
      }, (error) => {
        const details = error?.details;
        const detailMessage =
          (typeof details === 'string' && details) ||
          (details && typeof details.message === 'string' && details.message) ||
          '';
        const fallback = error?.message || '';
        const message =
          detailMessage ||
          (fallback && !fallback.includes('Invalid request') ? fallback : '') ||
          'There was an error cloning the link!';
        this.fs.error(message);
        onDone?.();
      });
  }

  formatLinkTypeLabel(link) {
    if (link?.type === 'generate') return 'generate';
    if (link?.type === 'import') return 'import';
    if (link?.type === 'url') return 'url';
    return 'link';
  }

  formatDescriptionCell(record) {
    const label = record.fieldLabel || '';
    if (!record.isDefaultLink) return label;
    return `<span class="associated-template-links-default-badge" title="Default template link"><i class="fa fa-star" aria-hidden="true"></i></span>${label}`;
  }

  formatLocationCell(record) {
    const typeLabel = String(record.typeDisplay || '').toUpperCase();
    const badge = typeLabel
      ? `<span class="label label-default">${typeLabel}</span>`
      : '';
    if (record.link?.type === 'url') {
      return badge;
    }
    const location = record.tableDisplay || '';
    if (!location) return badge;
    if (!badge) return location;
    return `${location} ${badge}`;
  }

  formatLocationDisplay(link) {
    if (link.type === 'url') return 'URL';
    if (link.type === 'generate') {
      const tableName = (link.table && (link.table.name || link.table.id)) || '—';
      return `Document Generation (${tableName})`;
    }
    if (link.type === 'import') {
      const tableName = (link.table && (link.table.name || link.table.id)) || '—';
      return `Automatic Record Import (${tableName})`;
    }
    const tableName = (link.table && (link.table.name || link.table.id)) || '—';
    const fieldId = link.field?.id;
    if (fieldId != null && String(fieldId).trim() !== '') {
      return `${tableName} (${fieldId})`;
    }
    return tableName;
  }

  formatTargetLines(link, refNameById) {
    if (!link.targets?.length) {
      if (link.type === 'url' || link.table?.id) return ['Download only'];
      return [];
    }
    return link.targets.map((t) => {
      const action = String(t.action ?? t.mode ?? '');
      const actionLabel = action ? action.charAt(0).toUpperCase() + action.slice(1) : '';
      return `${refNameById[t.referenceId] || t.referenceId}: ${actionLabel}`;
    });
  }

  formatTargets(link, refNameById) {
    return this.formatTargetLines(link, refNameById).join('<br/>');
  }

  buildSearchText(link, refNameById) {
    const description = (link.field && link.field.label) || '';
    const typeLabel = this.formatLinkTypeLabel(link);
    const location = this.formatLocationDisplay(link);
    const targets = this.formatTargetLines(link, refNameById).join(' ');
    return `${description} ${typeLabel} ${location} ${targets}`.trim().toLowerCase();
  }

  resolvePublicUrl(link) {
    if (link.type === 'generate' || link.type === 'import') {
      return this.buildWebhookEditUrl(link) || (link.field?.publicUrl || '');
    }
    if (link.type === 'url' && link.linkId && this.ts.template?.id) {
      return this.urlClipCopy.getUrlLinkUrl(this.ts.template, link.linkId);
    }
    return (link.field && link.field.publicUrl) || '';
  }

  buildWebhookEditUrl(link) {
    const webhookId = link.field?.id != null ? String(link.field.id).trim() : '';
    const tableId = link.table?.id != null ? String(link.table.id).trim() : '';
    const realm =
      (link.realm && String(link.realm).trim()) ||
      (this.ts.template?.realm && String(this.ts.template.realm).trim()) ||
      '';
    if (!webhookId || !tableId || !realm) return '';
    return `https://${realm}.quickbase.com/db/${tableId}?a=GenWebhookEdit&id=${webhookId}`;
  }

  toRecords(links) {
    const refNameById = {};
    (this.ts.references || []).forEach((r) => {
      refNameById[r.id] = r.name || r.tableSchema?.tableName || r.id;
    });
    return (links || []).map((link) => {
      const publicUrl = this.resolvePublicUrl(link);
      const linkRecord = link.type === 'url' && publicUrl && link.field
        ? { ...link, field: { ...link.field, publicUrl } }
        : link;
      const typeDisplay = this.formatLinkTypeLabel(link);
      return {
        link: linkRecord,
        linkId: link.linkId,
        typeDisplay,
        typeSort: typeDisplay,
        tableDisplay: this.formatLocationDisplay(link),
        tableSort: String(
          link.type === 'url'
            ? 'url'
            : this.formatLocationDisplay(link)
        ).toLowerCase(),
        fieldLabel: (link.field && link.field.label) || '',
        isDefaultLink: this.isDefaultTemplateLink(link.linkId),
        fieldSort: String((link.field && link.field.label) || '').toLowerCase(),
        searchText: this.buildSearchText(link, refNameById),
        active: link.active !== false,
        updatedAt: link.updatedAt ?? link.createdAt ?? null,
        targetsSummary: this.formatTargets(link, refNameById),
        publicUrl,
      };
    });
  }

  async loadRecords() {
    try {
      await this.ts.getTemplateData();
      const request = this.as.includeConnectionInRequest({
        payload: { action: 'listLinks', templateId: this.templateId },
      });
      const response = await this.ts.linkManagement(request);
      const data = response && response.data;
      this.records = this.toRecords((data && data.links) || []);
    } catch (e) {
      this.fs.error('Could not load template links.');
      this.records = [];
    } finally {
      this.loadingNote = null;
    }
  }

  toggleActive(record) {
    const linkId = record?.linkId;
    if (!linkId || this.toggling[linkId]) return;
    this.toggling[linkId] = true;

    const nextActive = !record.active;
    const label = record.fieldLabel || 'Link';
    const request = this.as.includeConnectionInRequest({
      payload: {
        action: 'updateLinkActive',
        templateId: this.templateId,
        linkId,
        active: nextActive,
      },
    });

    this.ts.linkManagement(request)
      .then(() => {
        record.active = nextActive;
        if (record.link) record.link.active = nextActive;
        delete this.toggling[linkId];
        this.fs.success(`Link "${label}" was ${nextActive ? 'activated' : 'deactivated'} successfully!`);
      }, () => {
        this.fs.error('There was an error updating the link!');
        delete this.toggling[linkId];
      });
  }

  cancel() {
    this.onCancel();
  }
}

export default {
  bindings: {
    templateId: '<',
    onCancel: '&',
    onDismissList: '&',
    onEditLink: '&',
    onNewLink: '&',
  },
  templateUrl: 'form-builder/build-wizard/associated-template-links/associated-template-links.component.html',
  controller: AssociatedTemplateLinksCtrl,
};
